const PageBarCodeStyle = ({ isLarge }) => {
  return (
    <style>
      {`
            @page {
              size: "landscape";
              margin: ${isLarge ? "2.1cm 3.88cm 4.1cm 0.89cm" : "5.18cm 3.88cm 1.1cm 0.89cm"};
            }
          `}
    </style>
  );
};

export default PageBarCodeStyle;
